
import React from 'react';
import Shikar2025 from 'views/Shikar2025'

const SecondarySchoolpage = () => {
  return <Shikar2025/>;
};

export default SecondarySchoolpage;